// src/components/shared/Header.tsx
import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/LandingPage.css'; // Reuse the logo styles

interface HeaderProps {
  showNav?: boolean;
  title?: string;
  subtitle?: string;
}

const Header: React.FC<HeaderProps> = ({ 
  showNav = true, 
  title = "PROMETHEUS", 
  subtitle = "Workforce Analytics" 
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const logoRef = useRef<HTMLDivElement>(null);
  
  const handleViewDemo = () => {
    navigate('/dashboard');
  };
  
  const handleGoHome = () => {
    navigate('/');
  };
  
  // Add logo hover effect
  useEffect(() => {
    const logoContainer = logoRef.current;
    if (!logoContainer) return;
    
    const handleMouseMove = (e: MouseEvent) => {
      const rect = logoContainer.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const rotateY = ((x - centerX) / centerX) * 5;
      const rotateX = ((centerY - y) / centerY) * 5;
      
      logoContainer.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.05)`;
    };
    
    const handleMouseLeave = () => {
      logoContainer.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale(1)';
    };
    
    logoContainer.addEventListener('mousemove', handleMouseMove);
    logoContainer.addEventListener('mouseleave', handleMouseLeave);
    
    return () => {
      logoContainer.removeEventListener('mousemove', handleMouseMove);
      logoContainer.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <header className="header">
      <div className="logo-container" ref={logoRef}>
        <div className="logo-wrapper" onClick={handleGoHome} style={{ cursor: 'pointer' }}>
          {/* Logo Glow Effect */}
          <div className="logo-glow"></div>
          
          {/* Logo Orbital Rings */}
          <div className="logo-orbital-ring"></div>
          <div className="logo-orbital-ring ring-2"></div>
          <div className="logo-orbital-ring ring-3"></div>
          
          {/* Actual Prometheus Logo */}
          <div className="logo-image-container">
            <img 
              src="/resources/prometheus_logo.jpg" 
              alt="Prometheus Workforce Analytics"
              className="logo-image"
            />
            <div className="logo-shine"></div>
          </div>
        </div>
        
        {/* Logo Text */}
        <div className="logo-text" onClick={handleGoHome} style={{ cursor: 'pointer' }}>
          <span className="logo-primary">{title}</span>
          <span className="logo-secondary">{subtitle}</span>
        </div>
      </div>
      
      {showNav && (
        <nav className="nav">
          {location.pathname !== '/' && (
            <button className="nav-button secondary" onClick={() => navigate('/')}>
              ← Back to Home
            </button>
          )}
          {location.pathname !== '/dashboard' && (
            <button className="nav-button" onClick={handleViewDemo}>
              Live Dashboard
            </button>
          )}
          {location.pathname !== '/interventions' && (
            <button className="nav-button secondary" onClick={() => navigate('/interventions')}>
              Interventions
            </button>
          )}
        </nav>
      )}
    </header>
  );
};

export default Header;
